var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1129_452)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47718 2 2.00002 6.47715 2.00002 12C2.00002 13.8806 2.51821 15.6372 3.41902 17.1381C3.56253 17.3772 3.59968 17.6653 3.52151 17.933L2.46288 21.5581L6.17664 20.5314C6.4372 20.4594 6.71582 20.4959 6.94901 20.6327C8.43052 21.5016 10.1555 22 12 22C17.5229 22 22 17.5228 22 12C22 6.47715 17.5229 2 12 2ZM2.3506e-05 12C2.3506e-05 5.37258 5.37261 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C9.94378 24 8.00587 23.482 6.31236 22.5689L1.26648 23.9638C0.91692 24.0605 0.542435 23.9603 0.28784 23.702C0.0332449 23.4437 -0.0615481 23.0678 0.0401174 22.7197L1.48223 17.7814C0.537392 16.0659 2.3506e-05 14.0944 2.3506e-05 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9266 14.2152L14.4042 14.6706C14.1488 14.8933 13.7955 14.9771 13.4812 14.852C11.22 13.9518 10.1312 11.7644 9.71052 10.6584C9.56133 10.2662 9.72414 9.83911 10.0715 9.60617C10.5625 9.27683 10.6588 8.59061 10.2775 8.13742L9.49229 7.20404L8.75234 6.34667C8.35158 5.8823 7.63421 5.88483 7.23669 6.35201L6.45225 7.27392C6.07034 7.72275 5.90268 8.31701 6.05713 8.88702C6.42596 10.2483 7.36755 12.89 9.49225 15.0275C11.6771 17.2254 14.1269 17.8236 15.2986 17.9864C15.7487 18.0489 16.1893 17.8917 16.5441 17.6061L17.6245 16.7366C18.0901 16.3619 18.1286 15.6631 17.7069 15.2389L17.571 15.1022C17.5217 15.0525 17.4673 15.0082 17.4088 14.97L16.1272 14.1319C15.7532 13.8874 15.2636 13.9213 14.9266 14.2152Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1129_452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappLogo);
export default __webpack_public_path__ + "static/media/whatsapp-logo.5a636a1061f2af0133d0ff89e1652aed.svg";
export { ForwardRef as ReactComponent };